import {
    BRAND_FRAGMENT,
    CONTACT_GROUP_FRAGMENT,
    DISCLAIMER_FRAGMENT,
    ENVIRONMENTAL_CLAIMS_FRAGMENT,
    IMAGE_FRAGMENT,
    PRODUCT_CALLOUT_FRAGMENT,
    PRODUCT_DYNAMIC_DIMENSIONS_FRAGMENT,
    PRODUCT_ENVIRONMENTAL_FRAGMENT,
    PRODUCT_FRAGMENT,
    PRODUCT_MEDIA_FRAGMENT,
    PRODUCT_SPECIFICATION_FRAGMENT,
    PROMOTION_FRAGMENT, RESOURCE_FRAGMENT,
    VIDEO_FRAGMENT
} from "../definitions/fragments";
import {
    QUERY_COLLECTION,
    QUERY_COMPARISON_TABLE,
    QUERY_COMPATIBLE_WITH,
    QUERY_CONTACT_GROUP,
    QUERY_EMPLOYEE_NAVIGATION,
    QUERY_HIGH_LEVEL_CALLOUT,
    QUERY_LISTS,
    QUERY_MEDIA,
    QUERY_OFF_CANVAS,
    QUERY_PRODUCT,
    QUERY_PRODUCT_PRICE,
    QUERY_PRODUCT_PRICING,
    QUERY_PRODUCT_RECOMMENDATIONS,
    QUERY_QUESTIONS,
    QUERY_RATINGS,
    QUERY_RECENTLY_VIEWED,
    QUERY_SPECIFICATIONS,
    QUERY_STOCK_INFORMATION
} from "../definitions/queries";
import {
    MUTATION_CREATE_ARTWORK,
    MUTATION_CREATE_LIST,
    MUTATION_CREATE_LIST_ITEM,
    MUTATION_CREATE_NOTIFY_PRODUCT,
    MUTATION_CREATE_REVIEW_FEEDBACK,
    MUTATION_DELETE_LIST_ITEM
} from "../definitions/mutations";

export const contentService = {
    artwork: {
        create: MUTATION_CREATE_ARTWORK
    },
    fragments: {
        brand: BRAND_FRAGMENT,
        callout: PRODUCT_CALLOUT_FRAGMENT,
        contactGroup: CONTACT_GROUP_FRAGMENT,
        disclaimers: DISCLAIMER_FRAGMENT,
        dynamicDimensions: PRODUCT_DYNAMIC_DIMENSIONS_FRAGMENT,
        environmental: PRODUCT_ENVIRONMENTAL_FRAGMENT,
        environmentalClaims: ENVIRONMENTAL_CLAIMS_FRAGMENT,
        images: IMAGE_FRAGMENT,
        media: PRODUCT_MEDIA_FRAGMENT,
        product: PRODUCT_FRAGMENT,
        promotion: PROMOTION_FRAGMENT,
        resource: RESOURCE_FRAGMENT,
        specifications: PRODUCT_SPECIFICATION_FRAGMENT,
        videos: VIDEO_FRAGMENT
    },
    lists: {
        create: MUTATION_CREATE_LIST,
        items: {
            create: MUTATION_CREATE_LIST_ITEM,
            delete: MUTATION_DELETE_LIST_ITEM
        },
        query: QUERY_LISTS
    },
    media: {
        connection: {
            query: QUERY_MEDIA
        }
    },
    notifyProduct: {
        create: MUTATION_CREATE_NOTIFY_PRODUCT
    },
    product: {
        collection: QUERY_COLLECTION,
        comparisonTable: QUERY_COMPARISON_TABLE,
        compatibility: QUERY_COMPATIBLE_WITH,
        contactGroup: QUERY_CONTACT_GROUP,
        details: QUERY_PRODUCT,
        employeeNavigation: QUERY_EMPLOYEE_NAVIGATION,
        highLevelCallout: QUERY_HIGH_LEVEL_CALLOUT,
        offCanvas: QUERY_OFF_CANVAS,
        price: QUERY_PRODUCT_PRICE,
        prices: QUERY_PRODUCT_PRICING,
        recentlyViewed: QUERY_RECENTLY_VIEWED,
        recommendations: QUERY_PRODUCT_RECOMMENDATIONS,
        specifications: QUERY_SPECIFICATIONS,
        stockInformation: QUERY_STOCK_INFORMATION
    },
    questions: {
        connection: {
            query: QUERY_QUESTIONS
        }
    },
    ratings: {
        query: QUERY_RATINGS,
        review: {
            feedback: {
                increment: MUTATION_CREATE_REVIEW_FEEDBACK
            }
        }
    }
};